import React from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Typography, useTheme } from '@material-ui/core'

import { BaseDialog } from 'components'

import daiStarIcon from 'images/dai-star-light-blue.svg'
import useStyles from './styles'

const NewAiInventoryDialog = ({
  open,
  setOpen,
  onSelectDai,
  onSelectManual,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Fazer cadastro de nova IA"
      dialogSize="xs"
      accentColor={theme.palette.primary.main}
      closeIconButton
      withoutBottomDivider
      fullWidth
    >
      <Typography variant="body1" className={classes.subtitle}>
        Escolha a forma que deseja para cadastrar sua nova Inteligência
        Artificial.
      </Typography>

      <Box className={classes.infoBox}>
        <Typography variant="body2">
          O cadastro guiado por IA é mais fácil e rápido. Enquanto o manual é
          bom para quem sabe o que está fazendo.
        </Typography>
      </Box>

      <Box className={classes.actions}>
        <Button
          fullWidth
          variant="outlined"
          className={`${classes.button} ${classes.daiButton}`}
          onClick={onSelectDai}
        >
          <img src={daiStarIcon} alt="" className={classes.daiIcon} />
          Cadastrar com a DAI
        </Button>
        <Button
          fullWidth
          variant="contained"
          className={`${classes.button} ${classes.manualButton}`}
          onClick={onSelectManual}
        >
          Cadastrar manualmente
        </Button>
      </Box>
    </BaseDialog>
  )
}

NewAiInventoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSelectDai: PropTypes.func.isRequired,
  onSelectManual: PropTypes.func.isRequired,
}

export default NewAiInventoryDialog
